import { AxiosRequestHeaders } from "axios";

export default abstract class AdminApiTokenSupport {
  protected withAuthorization(
    headers?: AxiosRequestHeaders | object,
    token?: string
  ) {
    return {
      headers: {
        ...(headers || {}),
        Authorization: `Bearer ${
          token || localStorage.getItem("x-admin-notes-access-token")
        }`,
      },
    };
  }
}
